/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Status_FailedInputs */

const en_embed_captions_status_failed = /** @type {(inputs: Embed_Captions_Status_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed`)
};

const fr_embed_captions_status_failed = /** @type {(inputs: Embed_Captions_Status_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Echoue`)
};

const de_embed_captions_status_failed = /** @type {(inputs: Embed_Captions_Status_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehlgeschlagen`)
};

const it_embed_captions_status_failed = /** @type {(inputs: Embed_Captions_Status_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fallito`)
};

const ru_embed_captions_status_failed = /** @type {(inputs: Embed_Captions_Status_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Неуспешный`)
};

const es_embed_captions_status_failed = /** @type {(inputs: Embed_Captions_Status_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fallido`)
};

const zh_cn2_embed_captions_status_failed = /** @type {(inputs: Embed_Captions_Status_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`失败的`)
};

const ja_embed_captions_status_failed = /** @type {(inputs: Embed_Captions_Status_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`失敗した`)
};

const hi_embed_captions_status_failed = /** @type {(inputs: Embed_Captions_Status_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`असफल`)
};

const pt_pt2_embed_captions_status_failed = /** @type {(inputs: Embed_Captions_Status_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fracassado`)
};

/**
* | output |
* | --- |
* | "Failed" |
*
* @param {Embed_Captions_Status_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_status_failed = /** @type {((inputs?: Embed_Captions_Status_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Status_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_embed_captions_status_failed(inputs)
	if (locale === "de") return de_embed_captions_status_failed(inputs)
	if (locale === "it") return it_embed_captions_status_failed(inputs)
	if (locale === "ru") return ru_embed_captions_status_failed(inputs)
	if (locale === "es") return es_embed_captions_status_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_embed_captions_status_failed(inputs)
	if (locale === "ja") return ja_embed_captions_status_failed(inputs)
	if (locale === "hi") return hi_embed_captions_status_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_embed_captions_status_failed(inputs)
	return en_embed_captions_status_failed(inputs)
});